import { render, staticRenderFns } from "./TechRoadmapSwiper.vue?vue&type=template&id=f24917d4&scoped=true&"
import script from "./TechRoadmapSwiper.vue?vue&type=script&lang=js&"
export * from "./TechRoadmapSwiper.vue?vue&type=script&lang=js&"
import style0 from "./TechRoadmapSwiper.vue?vue&type=style&index=0&id=f24917d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24917d4",
  null
  
)

export default component.exports